export default __webpack_public_path__ + "locales/ru/FormGallery.json?hash=2f5388ebb0304e389f48ea41343c6777";